import { render, staticRenderFns } from "./DetailAgeGroupReport.vue?vue&type=template&id=fad803d8&scoped=true"
import script from "./DetailAgeGroupReport.vue?vue&type=script&lang=js"
export * from "./DetailAgeGroupReport.vue?vue&type=script&lang=js"
import style0 from "./DetailAgeGroupReport.vue?vue&type=style&index=0&id=fad803d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fad803d8",
  null
  
)

export default component.exports